import { API_URL } from '../../shared/actions'
import { customReducer } from './customReducer'

export const uploadHeaderReducer = (state, action) => {
  const {
    UPLOAD_HEADER: { GET_ALL_UPLOAD_HEADERS, ADD_UPLOAD_HEADER, EDIT_UPLOAD_HEADER, GET_UPLOAD_HEADER, DELETE_MANY_UPLOAD_HEADER },
  } = API_URL
  return customReducer(state, action, 'uploadHeaders', [GET_ALL_UPLOAD_HEADERS, ADD_UPLOAD_HEADER, EDIT_UPLOAD_HEADER, GET_UPLOAD_HEADER, DELETE_MANY_UPLOAD_HEADER])
}
